/**
 * Cart Fee Sync - Mantém taxas de ativação sincronizadas com planos
 * - Mundo plans → taxa-de-ativacao-plano-mundo (US$14)
 * - Demais plans → taxa-de-ativacao-demais-planos (US$8)
 * - Fee count always matches plan count per type
 *
 * Requires window.feeConfig.mundoVariantId and window.feeConfig.demaisVariantId
 * to be set (injected from theme.liquid via Liquid)
 */
async function syncCartFees() {
    try {
        var res = await fetch('/cart.js', { credentials: 'same-origin' });
        var cart = await res.json();

        var mundoPlanQty = 0;
        var europaPlanQty = 0;
        var otherPlanQty = 0;
        var mundoFee = null;
        var otherFee = null;
        var surchargeChina = null;
        var surchargeEuropa = null;       // pacote único Europa (Suíça e Turquia)
        var surchargeEuropaDupes = [];    // itens duplicados de destino adicional Europa a remover

        // Declarados antes do loop para permitir marcação de duplicatas dentro do loop
        var updates = {};
        var needsUpdate = false;
        var needsAdd = [];

        for (var i = 0; i < cart.items.length; i++) {
            var item = cart.items[i];
            var handle = item.handle || '';

            if (handle === 'taxa-de-ativacao-plano-mundo') {
                if (mundoFee === null) {
                    mundoFee = { key: item.key, quantity: item.quantity };
                } else {
                    // Duplicata de taxa Mundo — marca para remoção imediata
                    updates[item.key] = 0;
                    needsUpdate = true;
                }
            } else if (handle.indexOf('taxa-de-ativacao') !== -1) {
                if (otherFee === null) {
                    otherFee = { key: item.key, quantity: item.quantity };
                } else {
                    // Duplicata de taxa demais planos — marca para remoção imediata
                    updates[item.key] = 0;
                    needsUpdate = true;
                }
            } else if (handle === 'destino-adicional') {
                var dest = (item.properties && item.properties['Destino Adicional']) || '';
                if (dest.indexOf('China') !== -1 || dest.indexOf('china') !== -1) {
                    surchargeChina = { key: item.key, quantity: item.quantity };
                } else {
                    // Qualquer destino adicional não-China é o pacote Europa
                    // (Suíça, Turquia, ou Suíça e Turquia — pacote único)
                    if (surchargeEuropa === null) {
                        surchargeEuropa = { key: item.key, quantity: item.quantity };
                    } else {
                        // Item duplicado de destino Europa (legado) — marca para remoção
                        surchargeEuropaDupes.push(item.key);
                    }
                }
            } else if (handle.indexOf('mundo') !== -1) {
                mundoPlanQty += item.quantity;
            } else {
                if (handle.indexOf('europa') !== -1) {
                    europaPlanQty += item.quantity;
                }
                otherPlanQty += item.quantity;
            }
        }

        // Sync mundo fees
        var currentMundoFees = mundoFee ? mundoFee.quantity : 0;
        if (currentMundoFees !== mundoPlanQty) {
            if (mundoPlanQty === 0 && mundoFee) {
                updates[mundoFee.key] = 0;
                needsUpdate = true;
            } else if (mundoPlanQty > 0 && mundoFee) {
                updates[mundoFee.key] = mundoPlanQty;
                needsUpdate = true;
            } else if (mundoPlanQty > 0 && !mundoFee && window.feeConfig && window.feeConfig.mundoVariantId) {
                needsAdd.push({ id: window.feeConfig.mundoVariantId, quantity: mundoPlanQty });
            }
        }

        // Sync other fees
        var currentOtherFees = otherFee ? otherFee.quantity : 0;
        if (currentOtherFees !== otherPlanQty) {
            if (otherPlanQty === 0 && otherFee) {
                updates[otherFee.key] = 0;
                needsUpdate = true;
            } else if (otherPlanQty > 0 && otherFee) {
                updates[otherFee.key] = otherPlanQty;
                needsUpdate = true;
            } else if (otherPlanQty > 0 && !otherFee && window.feeConfig && window.feeConfig.demaisVariantId) {
                needsAdd.push({ id: window.feeConfig.demaisVariantId, quantity: otherPlanQty });
            }
        }

        // Cap surcharges to main plan quantities (also handles auto-remove if plan is 0)
        if (surchargeChina && surchargeChina.quantity > mundoPlanQty) {
            updates[surchargeChina.key] = mundoPlanQty;
            needsUpdate = true;
        }
        // Pacote Europa único (Suíça e Turquia): cap à quantidade de planos Europa
        if (surchargeEuropa && surchargeEuropa.quantity > europaPlanQty) {
            updates[surchargeEuropa.key] = europaPlanQty;
            needsUpdate = true;
        }
        // Remove itens duplicados de destino adicional Europa (legado carrinho antigo)
        for (var d = 0; d < surchargeEuropaDupes.length; d++) {
            updates[surchargeEuropaDupes[d]] = 0;
            needsUpdate = true;
        }

        // Apply updates (quantity changes / removals)
        if (needsUpdate) {
            await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ updates: updates })
            });
        }

        // Apply adds (new fee items)
        if (needsAdd.length > 0) {
            await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: needsAdd })
            });
        }

        return needsUpdate || needsAdd.length > 0;
    } catch (e) {
        console.error('Fee sync error:', e);
        return false;
    }
}
